<div class="accordion" id="accordionExample" style="margin-top: -25px;">
    <div class="accordion-item">
        <h2 class="accordion-header" id="heading1">
            <button aria-controls="collapse1" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse1" data-bs-toggle="collapse" type="button">
                Overige onroerende zaken
            </button>
        </h2>
        <div aria-labelledby="heading1" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse1">
            <div class="accordion-body">
                Bij overige onroerende zaken in box 3 gaat het bijvoorbeeld om:
                <li class="list">een tweede woning, bijvoorbeeld een vakantiewoning die je niet verhuurt</li>
                <li class="list">je overige onroerende zaken, zoals:<br/>
                    - een woning die of kantoorpand dat je verhuurt of verpacht<br/>
                    - een garage die niet naast de eigen woning ligt, maar een paar straten verder
                    een los perceel, zoals een weiland
                </li>
                <div class="space10"></div>

                Het maakt niet uit of je deze onroerende zaken hebt in Nederland of buiten Nederland.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading2">
            <button aria-controls="collapse2" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse2" data-bs-toggle="collapse" type="button">
                Waardering overige onroerende zaken
            </button>
        </h2>
        <div aria-labelledby="heading2" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse2">
            <div class="accordion-body">
                <b>Waarde tweede woning</b><br/>
                Heb je een tweede woning in Nederland? Dan gaat het om WOZ-waarde met waardepeildatum 1
                januari {{ this.year - 1 }}. Deze staat op de WOZ-beschikking die je begin {{ this.year }} van je
                gemeente hebt gekregen.
                <div class="space10"></div>

                Heb je een tweede woning buiten Nederland? Dan gaat het om de waarde in het economisch verkeer in
                onbewoonde en onverhuurde staat op 1 januari {{ this.year - 1 }}.
                <div class="space10"></div>

                <b>Waarde overige onroerende zaken</b><br/>
                Welke waarde je moet aangeven hangt af van het soort bezitting dat je hebt op 1 januari {{ this.year }}.
                <div class="space10"></div>

                Bij een woning in Nederland gaat het om de WOZ-waarde met waardepeildatum 1 januari {{ this.year - 1 }}.<br/>
                Bij een woning buiten Nederland gaat het om de waarde in het economisch verkeer in onbewoonde en
                onverhuurde staat op 1 januari  {{ this.year - 1 }}. <br/>
                Als je de woning verhuurt of verpacht, kan het gaan
                om een percentage van die waarde, volgens de 'Tabel waarde verhuurde of verpachte woning'. In het
                programma wordt aan de hand van de ingevulde gegevens de tabel toegepast.

                <div class="space10"></div>
                Let op! Heb je op 1 januari een woning die je pas in de loop van het jaar verhuurt of verpacht? Dan gaat
                het om de WOZ-waarde en niet een deel of percentage daarvan.

                <div class="space10"></div>
                In de volgende situaties gaat het wel om een deel van de waarde:
                <li class="list">je verhuurt een zelfstandig deel van een groter gebouw.</li>
                <li class="list">je verhuurt een niet-zelfstandig deel van je woning, bijvoorbeeld een kamer.</li>
                <div class="space10"></div>

                <b>Verhuur niet-zelfstandig deel woning</b><br/>
                Let op! Verhuur je een niet-zelfstandig deel van de woning die je hoofdverblijf is? En voldoet je aan de
                voorwaarden van de kamerverhuurvrijstelling? Dan valt het verhuurde deel van je woning niet in box 3,
                maar onder de eigenwoningregeling. Je geeft je woning dan aan als 'Eigen woning'.
                <div class="space10"></div>

                <b>Geen woning?</b><br/>
                Gaat het niet om een woning, maar bijvoorbeeld om een bedrijfspand of een los perceel? Dan gaat het om
                de waarde in het economisch verkeer op 1 januari {{ this.year }}.
                <div class="space10"></div>

                <b>WOZ-waarde zelfstandig deel van een groter gebouw</b><br/>
                Verhuur je een zelfstandig deel van een groter gebouw? En kan het verhuurde deel niet worden verkocht
                zonder het pand op te splitsen? Dan gaat het om de WOZ-waarde min € 20.000. Het programma houdt hier
                automatisch rekening mee.
                <div class="space10"></div>

                <b>Je verhuurt of verpacht een woning</b><br/>
                Verhuur je een woning geheel of gedeeltelijk? En heeft de huurder recht op huurbescherming? Of verpacht
                je de woning geheel of gedeeltelijk? En heb je met de pachter een pachtovereenkomst voor ten minste 12
                jaar? Dan gaat het om een percentage van de WOZ-waarde, volgens de 'Tabel waarde verhuurde of verpachte
                woning'. In het programma wordt aan de hand van de ingevulde gegevens de tabel toegepast.
                <div class="space10"></div>

                <b>Kale huur</b><br/>
                Het percentage van de WOZ-waarde hangt af van de jaarlijkse huur of pacht. Dit is de kale huur of pacht
                op jaarbasis.
                <div class="space10"></div>
                De kale huur is het bedrag waarvoor je de woning verhuurt, exclusief vergoedingen voor bijvoorbeeld
                energie en het gebruik van meubels. Pacht is het bedrag waarvoor je de woning verpacht, exclusief
                vergoedingen voor bijvoorbeeld energie en het gebruik van meubels.

            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading3">
            <button aria-controls="collapse3" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse3" data-bs-toggle="collapse" type="button">
                Verhuurd of verpachte woning
            </button>
        </h2>
        <div aria-labelledby="heading3" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse3">
            <div class="accordion-body">
                Kies 'Verhuurd' in de volgende situaties:<br/>

                <ul>
                    <li>Je verhuurde een woning die niet uw hoofdverblijf was.</li>
                    <li>Je verhuurde een zelfstandig deel van je woning. Dit deel van de woning kon je niet gebruiken
                        als hoofdverblijf
                    </li>
                    <li>Je verhuurde een niet-zelfstandig deel van je woning die je hoofdverblijf was en je voldeed niet
                        aan de voorwaarden kamerverhuurvrijstelling. Bijvoorbeeld omdat je meer dan het vrijgestelde
                        bedrag ontving aan
                        huur.
                    </li>
                </ul>
                <div class="space10"></div>
                Kies 'Verpacht' als je de onroerende zaak op 1 januari {{ year }} geheel of gedeeltelijk verpachtte.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading4">
            <button aria-controls="collapse4" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse4" data-bs-toggle="collapse" type="button">
                Recht op huurbescherming
            </button>
        </h2>
        <div aria-labelledby="heading4" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse4">
            <div class="accordion-body">
                Huurders van de volgende woningen hebben geen recht op huurbescherming:<br/>

                <ul>
                    <li>woonboten</li>
                    <li>winkelwoningen</li>
                    <li>dienstwoningen</li>
                    <li>recreatiewoningen</li>
                    <li>kamer in verpleeg- of verzorgingshuis (als er alleen een zorgovereenkomst is)</li>
                </ul>
                <div class="space10"></div>
                Er is ook geen huurbescherming voor de huurder als je verhuurt met een leegstandswetvergunning met
                toestemming van de hypotheekverstrekker.
                <div class="space10"></div>
                Kies 'nee' als er sprake was van een tijdelijk huurcontract. Bij een woning is dat een contract dat niet
                langer duurt dan 2 jaar en bij een kamer niet langer dan 5 jaar.
                <div class="space10"></div>
                In alle andere situaties heeft de huurder wel huurbescherming.
            </div>
        </div>
    </div>

    <div class="accordion-item">
        <h2 class="accordion-header" id="heading5">
            <button aria-controls="collapse5" aria-expanded="false" class="accordion-button collapsed"
                    data-bs-target="#collapse5" data-bs-toggle="collapse" type="button">
                Gecorrigeerde waarde bij huurbescherming
            </button>
        </h2>
        <div aria-labelledby="heading5" class="accordion-collapse collapse" data-bs-parent="#accordionExample"
             id="collapse5">
            <div class="accordion-body">
                Als de huurder recht had op huurbescherming of als de woning verpacht werd, wordt de WOZ-waarde
                gecorrigeerd met een bepaald percentage. Het inkomen in box 3 wordt daardoor lager.
                <div class="space10"></div>
                In de <a
                    href="https://www.belastingdienst.nl/data/online_aangifte/ih2025/contextafhankelijkehelp/nlw/da/waarde_verhuurde_of_verpachte_woning.htm"
                    target="_blank">"Tabel waarde verhuurde of verpachte woning"</a> vind je de percentages voor de
                gecorrigeerde WOZ-waarde bij huurbescherming.
                <div class="space10"></div>
                <b>Werkelijke waarde van de woning</b><br/>
                Het kan zijn dat de werkelijke waarde (de waarde in het economisch verkeer) van de woning nog lager is
                dan de gecorrigeerde WOZ-waarde. Bij de werkelijke waarde gaat het om de prijs die je voor de woning had
                kunnen krijgen als je de woning op de aangegeven datum (peildatum) zou hebben verkocht. Je mag
                rekening houden met omstandigheden die zorgen voor een lagere waarde van de woning.
                <div class="space10"></div>
                Als het verschil tussen de gecorrigeerde WOZ-waarde en de werkelijke waarde <b>meer dan 10%</b> is
                van de werkelijke waarde dan mage je voor de waarde van de woning in box 3 rekening met de
                waarde in het economisch verkeer. Vul dan bij de WOZ-waarde het gecorrigeerde bedrag in en geef aan dat
                er geen sprake is van een woning. Dan beantwoord je de vragen over verhuurde of verpachte dus niet.
        </div>
    </div>

</div>
